import useShareSecret from '../post/useShareSecret';
import useSlug from '../utils/router/useSlug';
import useIsPublicView from '../utils/useIsPublicView';

const useIsPublicDocumentationView = (): boolean => {
  const [postId] = useSlug('postSlug');
  const [topicId] = useSlug('topicSlug');
  const shareSecret = useShareSecret();
  const isPublicView = useIsPublicView();

  if (!isPublicView || !window.__slab.PUBLIC_ORG.settings.public) return false;
  if (topicId) return true;
  if (postId) return !shareSecret;

  return false;
};

export default useIsPublicDocumentationView;
